'use strict';

import holidaysCtrl from './holidayCtrl';

const MODULE_NAME = 'daupler.holidays';

const app = angular.module(MODULE_NAME, []);
app.controller('HolidaysCtrl', holidaysCtrl);

export default MODULE_NAME;
